/**
 * Shadow opacity for the 'umbra' light source.
 *
 * @type {Number}
 */
export const SHADOW_UMBRA_OPACITY = 0.2;

/**
 * Shadow opacity for the 'penumbra' light source.
 *
 * @type {Number}
 */
export const SHADOW_PENUMBRA_OPACITY = 0.14;

/**
 * Shadow opacity for the 'ambient' light source.
 *
 * @type {Number}
 */
export const SHADOW_AMBIENT_OPACITY = 0.12;

/**
 * Shadow RGB Color.
 *
 * @type {String}
 */
export const SHADOW_RGB = '221, 225, 239';
